import { Tag } from "antd";
import { FC } from "react";

interface DataTagProps {
  color: string;
  label: string;
}

export const DataTag: FC<DataTagProps> = ({ color, label }) => {
  return (
    <Tag color={color} key={label}>
      {label.toUpperCase()}
    </Tag>
  );
};
